var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 62,
    viewBox: "0 0 54 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1314 8.82751C25.0427 8.06087 24.3867 7.48669 23.6151 7.50023C22.8434 7.51377 22.208 8.11062 22.1462 8.8799C21.9646 11.1405 21.4139 14.7849 20.4615 18.3067C19.4875 21.9082 18.1749 25.0604 16.6343 26.6261C14.7394 28.5517 12.2701 29.7957 9.71956 30.6788C7.7972 31.3444 5.93334 31.7747 4.26747 32.1593C3.69986 32.2904 3.15524 32.4161 2.63912 32.5441C1.9343 32.7188 1.45584 33.3732 1.50319 34.0978C1.55055 34.8224 2.11013 35.409 2.83169 35.4905C7.02229 35.9637 13.0633 37.1701 17.1998 41.3739C17.8054 41.9894 18.4163 43.0691 18.9912 44.5695C19.5545 46.0397 20.0339 47.78 20.4445 49.5948C21.0576 52.3047 21.4929 55.0606 21.8359 57.2317C21.9548 57.9846 22.0626 58.6671 22.1629 59.253C22.2887 59.9885 22.9361 60.5197 23.6821 60.4994C24.428 60.4792 25.0457 59.9137 25.1314 59.1724L25.1485 59.0251L25.1485 59.0251C25.435 56.5486 25.8563 52.9188 26.6478 49.4571C27.0432 47.7281 27.5233 46.0765 28.109 44.6545C28.7005 43.2182 29.3642 42.1043 30.083 41.3739C31.6744 39.7566 34.2114 38.5076 36.9708 37.5337C39.2625 36.7249 41.5562 36.1548 43.3743 35.7029C43.7248 35.6157 44.0576 35.533 44.3694 35.4538C45.086 35.2717 45.5631 34.5945 45.4933 33.8584C45.4235 33.1223 44.8276 32.5468 44.0895 32.5027C42.6808 32.4185 40.0624 31.8618 37.3346 30.8298C34.593 29.7926 31.9735 28.3612 30.3971 26.6589C28.8686 25.0085 27.6657 21.8962 26.7792 18.3424C25.9116 14.8645 25.4114 11.246 25.1314 8.82751Z",
    fill: "#0562D2",
    stroke: "url(#paint0_linear_112_7617)",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0415 2.82474C44.9514 2.05917 44.2957 1.4865 43.525 1.50024C42.7543 1.51398 42.1194 2.10966 42.0567 2.87796C41.9949 3.63524 41.8033 4.88751 41.4717 6.09387C41.1185 7.37919 40.6896 8.29253 40.3187 8.66348C39.7697 9.21242 39.0184 9.60036 38.1542 9.8948C37.5018 10.1171 36.8895 10.2562 36.2922 10.392C36.0748 10.4414 35.8593 10.4904 35.6446 10.5427C34.9376 10.7152 34.4563 11.3702 34.5031 12.0964C34.5498 12.8226 35.1111 13.4105 35.8344 13.4908C37.3387 13.658 39.2584 14.0694 40.5255 15.3365C40.6064 15.4174 40.7712 15.6581 40.9651 16.1561C41.1475 16.6245 41.3107 17.201 41.4555 17.8311C41.6719 18.772 41.8228 19.7118 41.9474 20.488C41.9924 20.7682 42.0339 21.0271 42.0739 21.257C42.2015 21.9909 42.8484 22.52 43.5931 22.4994C44.3377 22.4789 44.9545 21.915 45.0415 21.1752L45.0477 21.1222L45.0477 21.1221C45.1531 20.2255 45.3021 18.97 45.5777 17.7837C45.8735 16.511 46.2412 15.6732 46.5779 15.3365C47.0029 14.9115 47.7622 14.5187 48.7378 14.1799C49.53 13.9048 50.3192 13.7116 50.9847 13.5487C51.1162 13.5165 51.2429 13.4854 51.3638 13.4552C52.0825 13.2755 52.5624 12.5981 52.4935 11.8605C52.4246 11.1229 51.8276 10.5461 51.0881 10.5026C50.6924 10.4793 49.8291 10.3074 48.8906 9.95805C47.9371 9.60308 47.1405 9.15037 46.713 8.69609C46.3364 8.29592 45.9424 7.39216 45.6212 6.12535C45.3192 4.93376 45.142 3.67958 45.0415 2.82474Z",
    fill: "#0562D2",
    stroke: "url(#paint1_linear_112_7617)",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_112_7617",
    x1: 44,
    y1: -14.3553,
    x2: 79.7954,
    y2: 8.67536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE5EC",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_112_7617",
    x1: 51,
    y1: -5.4079,
    x2: 63.9714,
    y2: 3.07354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE5EC",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.21afbcaf8a4ad1ff8067638543edd489.svg";
export { ForwardRef as ReactComponent };